import React, {Component} from "react";
import PropTypes from "prop-types";
import isBefore from "date-fns/is_before";
import Entry from "./Entry";
import Timeline from "./Timeline";
import WorkingTimeSum from "./WorkingTimeSum";
import WorkdayModel from "../models/workday";
import Octicon, {Pencil, X} from "@github/octicons-react/dist/index.umd";

export default class Workday extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isInEditMode: false
        }
    }

    onToggleEditMode = () => {
        this.setState({isInEditMode: !this.state.isInEditMode});
    };

    render() {
        if (this.props.dummy) {
            return (
                <WorkdayDummy/>
            )
        }

        if (this.state.isInEditMode) {
            return (
                <WorkdayEdit
                    model={this.props.model}
                    onToggleEditMode={this.onToggleEditMode}
                />
            )
        }
        return (
            <WorkdayReadOnly
                model={this.props.model}
                selectedEntry={this.props.selectedEntry}
                onSelectedEntryChanged={this.props.onSelectedEntryChanged}
                onToggleEditMode={this.onToggleEditMode}
            />
        )
    }
}

Workday.propTypes = {
    model: PropTypes.instanceOf(WorkdayModel),
    selectedEntry: PropTypes.number,
    dummy: PropTypes.bool,
    onSelectedEntryChanged: PropTypes.func,
};

class WorkdayReadOnly extends Component {
    renderEntries = () => {
        let entries = [];
        let lastDate;

        this.props.model.entries.forEach(entry => {
            let overlapsWithDateBefore = isBefore(entry.begin, lastDate);
            entries.push(
                <Entry
                    key={entry.id}
                    model={entry}
                    isSelected={this.props.selectedEntry === entry.id}
                    isOverlapping={overlapsWithDateBefore}
                    onClick={this.props.onSelectedEntryChanged}
                />);
            lastDate = entry.end;
        });

        return entries;
    };

    render() {
        return (
            <div className="col-sm p-1">
                <div className="card workday">
                    <div className="card-body py-2" style={{overflow: 'hidden'}}>
                        <Timeline
                            model={this.props.model}
                            selectedEntry={this.props.selectedEntry}
                            onSelectedEntryChanged={this.props.onSelectedEntryChanged}
                        />
                        <h5 className="card-title">
                            <button onClick={() => this.props.onToggleEditMode()} type="button" className="btn btn-outline-primary btn-sm mr-3"><Octicon icon={Pencil}/></button>
                            {this.props.model.dayFormat}
                        </h5>
                        <ul className="list-group">
                            {this.renderEntries()}
                        </ul>
                        <WorkingTimeSum entries={this.props.model.entries}/>
                    </div>
                </div>
            </div>
        )
    }
}

WorkdayReadOnly.propTypes = {
    model: PropTypes.instanceOf(WorkdayModel),
    selectedEntry: PropTypes.number,
    onSelectedEntryChanged: PropTypes.func.isRequired,
    onToggleEditMode: PropTypes.func.isRequired
};

class WorkdayEdit extends Component {
    render() {
        return (
            <div className="col-sm p-1">
                <div className="card border-warning workday">
                    <div className="card-body py-2" style={{overflow: 'hidden'}}>
                        <h5 className="card-title">
                            <button onClick={() => this.props.onToggleEditMode()} type="button" className="btn btn-outline-secondary btn-sm mr-3"><Octicon icon={X}/></button>
                            {this.props.model.dayFormat}
                        </h5>
                    </div>
                </div>
            </div>
        )
    }
}

WorkdayEdit.propTypes = {
    model: PropTypes.instanceOf(WorkdayModel),
    onToggleEditMode: PropTypes.func.isRequired
};

class WorkdayDummy extends Component {
    render() {
        return (
            <div className="col-sm p-1">
                <div className="card border-light">
                    <div className="card-body text-secondary py-2" style={{overflow: 'hidden'}}>
                        <h5 className="card-title">Keine Daten</h5>
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Workday.js